<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
@if (isLoading) {
  <app-loader></app-loader>
}

<div class="modal-header">
  <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss()">
    Close
  </button>
  <h4 class="modal-title text-center" id="modal-title">
    {{ !storeId ? 'Create New Store' : 'Edit Store' }}
  </h4>
</div>
<div class="modal-body">
  <form name="storeForm" #storeForm="ngForm">
    <div class="form-row justify-content-center">
      <div class="col-10">
        <div class="form-group">
          <fieldset>
            <legend>General Settings:</legend>
          </fieldset>
        </div>

        <div class="form-group">
          <label for="name">Name*</label>
          <input
            type="text"
            class="form-control"
            id="name"
            name="name"
            placeholder="Name"
            autocomplete="off"
            [(ngModel)]="store.name"
            required
            maxlength="100"
          />
        </div>

        <div class="form-group">
          <label for="External">Store Website Url*</label>
          <input
            type="url"
            class="form-control"
            id="External"
            name="External"
            placeholder="https://"
            autocomplete="on"
            [(ngModel)]="integration.websiteUrl"
            maxlength="100"
            required
          />
        </div>

        <div class="form-group">
          <label for="url">Store Unique Path (https://terrific.live/store-unique-path)</label>
          <input
            type="text"
            class="form-control"
            id="url"
            name="url"
            placeholder="Store Url"
            autocomplete="off"
            [(ngModel)]="internalUrl"
            required
            #url="ngModel"
            maxlength="100"
          />
          @if (url.errors?.duplicate) {
            <div class="invalid-feedback">Url already in use</div>
          }
        </div>

        <div class="form-group">
          <label for="storeCategory">Store Category*</label>
          <ng-select
            id="storeCategory"
            name="Store Category"
            placeholder="Store Category"
            [items]="storeCategoryOptions"
            [ngModel]="store.storeCategory"
            (ngModelChange)="onStoreCategoryChange($event)"
            autocomplete="off"
            required
            [clearable]="false"
            [style.position]="'relative'"
          >
          </ng-select>
        </div>

        <div class="form-group">
          <label for="industry">Industry*</label>
          <ng-select
            id="industry"
            name="Industry"
            [(ngModel)]="store.industry"
            placeholder="Select Industry"
            autocomplete="off"
            [clearable]="false"
            required
          >
            @for (item of industryList | keyvalue; track item) {
              <ng-option [value]="item.key">{{ item.value }}</ng-option>
            }
          </ng-select>
        </div>

        <div class="form-group">
          <label for="storeType">Store Type*</label>
          <ng-select
            id="storeType"
            name="Store Type"
            placeholder="Store Type"
            [items]="storeTypesOptions"
            bindLabel="name"
            [(ngModel)]="store.storeType"
            autocomplete="off"
            required
            [clearable]="false"
            [style.position]="'relative'"
          >
          </ng-select>
        </div>

        <div class="form-group">
          <label for="StoreCurrency">Store Currency*</label>
          <ng-select
            id="StoreCurrency"
            name="Store Currency"
            placeholder="Store Currency"
            [items]="currencies"
            bindLabel="code"
            [(ngModel)]="currency"
            autocomplete="off"
            required
            [clearable]="false"
            [style.position]="'relative'"
          >
          </ng-select>
        </div>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="isPublished"
              name="isPublished"
              [(ngModel)]="store.isPublished"
            />
            <label class="custom-control-label" for="isPublished">Is Published</label>
          </div>
        </div>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="haveTheme"
              name="haveTheme"
              [(ngModel)]="haveTheme"
            />
            <label class="custom-control-label" for="haveTheme">Have Theme</label>
          </div>
        </div>
        @if (haveTheme) {
          <div class="form-group ml-4">
            <label for="primary">Primary Color</label>
            <input
              type="color"
              class="form-control"
              id="primary"
              name="primary"
              placeholder="Store primary color"
              autocomplete="off"
              [(ngModel)]="theme.primaryColor"
            />
          </div>
        }
        @if (haveTheme) {
          <div class="form-group ml-4">
            <label for="secondary">Secondary Color</label>
            <input
              type="color"
              class="form-control"
              id="secondary"
              name="secondary"
              placeholder="Store secondary color"
              autocomplete="off"
              [(ngModel)]="theme.secondaryColor"
            />
          </div>
        }

        @if (store.storeCategory !== StoreCategory.Media) {
          <div class="form-group">
            <fieldset>
              <legend>E-commerce Settings:</legend>
            </fieldset>
          </div>

          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="externalCart"
                name="externalCart"
                [(ngModel)]="store.externalCart"
              />
              <label class="custom-control-label" for="externalCart"
                >External cart (go to product)</label
              >
            </div>
          </div>

          <div class="form-group">
            <label for="leadImagePosition">Lead product image</label>
            <ng-select
              id="leadImagePosition"
              name="leadImagePosition"
              placeholder="1"
              [items]="leadImagePositions"
              [(ngModel)]="store.leadImagePosition"
              [clearable]="false"
            >
            </ng-select>
          </div>

          <div class="form-group">
            <label for="paymentSupplier">Payment Supplier*</label>
            <ng-select
              id="paymentSupplier"
              name="paymentSupplier"
              placeholder="Payment Supplier"
              [items]="paymentSuppliers"
              bindLabel="name"
              bindValue="value"
              [(ngModel)]="store.paymentSupplier"
              autocomplete="off"
              required
              [clearable]="false"
            >
            </ng-select>
          </div>

          <div class="form-group">
            <label for="cartPath">Store Checkout Path</label>
            <input
              type="url"
              class="form-control"
              id="cartPath"
              name="cartPath"
              placeholder="checkout"
              autocomplete="on"
              [(ngModel)]="integration.cartPath"
              maxlength="100"
            />
          </div>

          @if (isCronScheduleEditable) {
            <div class="form-group">
              <label for="cronExp">Automatic Sync Schedule (CRON)</label>
              <div id="edit-cron-div">
                <input
                  type="text"
                  class="form-control"
                  id="cronExp"
                  name="cronExp"
                  placeholder="CRON expression"
                  autocomplete="off"
                  [(ngModel)]="integration.cronScheduledSync"
                  minlength="3"
                  maxlength="100"
                  disabled
                />
                <button
                  type="button"
                  id="edit-cron-button"
                  class="btn btn-yellow w-132"
                  (click)="openCronExpressionEditModal()"
                >
                  Edit
                </button>
              </div>
            </div>
          }

          <div class="form-group">
            <label for="integrationClass">Integration Class*</label>
            <ng-select
              id="integrationClass"
              name="Integration Class*"
              [ngModel]="integration.integrationClass"
              (ngModelChange)="onIntegrationClassChange($event)"
              autocomplete="off"
              [clearable]="false"
              required
            >
              <ng-option value="BaseGeneric">BaseGeneric</ng-option>
              <ng-option value="CharlottedogclubCustom">CharlottedogclubCustom</ng-option>
              <ng-option value="FloweryCustom">FloweryCustom</ng-option>
              <ng-option value="GenericCsvCustom">GenericCsvCustom</ng-option>
              <ng-option value="PanecoCustom">PanecoCustom</ng-option>
              <ng-option value="PriceshoesCustom">PriceshoesCustom</ng-option>
              <ng-option [value]="sfccIntegrationClass">{{ sfccIntegrationClass }}</ng-option>
              <ng-option value="LoupedCustom">LoupedCustom</ng-option>
              <ng-option value="ShopifyCustom">ShopifyCustom</ng-option>
              <ng-option value="MaxbpCustom">MaxbpCustom</ng-option>
              <ng-option value="NaturaBrazilCustom">NaturaBrazilCustom</ng-option>
              <ng-option value="AvonBrazilCustom">AvonBrazilCustom</ng-option>
              <ng-option value="TiendanubeCustom">TiendanubeCustom</ng-option>
              <ng-option value="UrbanicaCustom">UrbanicaCustom</ng-option>
              <ng-option value="VerticheCustom">VerticheCustom</ng-option>
              <ng-option value="VtexCustom">VtexCustom</ng-option>
              <ng-option value="WoocommerceCustom">WoocommerceCustom</ng-option>
            </ng-select>
          </div>

          @if (isSfccIntegration) {
            <div class="border border-white mb-4">
              <div class="card-header">SFCC Configuration</div>
              <div class="card-body">
                <div class="form-group">
                  <label for="sfccScapiHost">SCAPI Host*</label>
                  <input
                    type="url"
                    class="form-control"
                    id="sfccScapiHost"
                    name="sfccScapiHost"
                    placeholder="https://short-code.api.commercecloud.salesforce.com"
                    autocomplete="off"
                    [(ngModel)]="integration.sfccIntegrationConfig!.scapiHost"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="sfccOrganizationId">Organization ID*</label>
                  <input
                    type="text"
                    class="form-control"
                    id="sfccOrganizationId"
                    name="sfccOrganizationId"
                    autocomplete="off"
                    [(ngModel)]="integration.sfccIntegrationConfig!.organizationId"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="sfccSiteId">Site ID*</label>
                  <input
                    type="text"
                    class="form-control"
                    id="sfccSiteId"
                    name="sfccSiteId"
                    autocomplete="off"
                    [(ngModel)]="integration.sfccIntegrationConfig!.siteId"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="sfccLocale">Locale*</label>
                  <input
                    type="text"
                    class="form-control"
                    id="sfccLocale"
                    name="sfccLocale"
                    placeholder="en"
                    autocomplete="off"
                    [(ngModel)]="integration.sfccIntegrationConfig!.locale"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="sfccSlasClientId">SLAS Client ID*</label>
                  <input
                    type="text"
                    class="form-control"
                    id="sfccSlasClientId"
                    name="sfccSlasClientId"
                    autocomplete="off"
                    [(ngModel)]="integration.sfccIntegrationConfig!.slasClientId"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="sfccSlasClientSecret">SLAS Client Secret*</label>
                  <input
                    type="text"
                    class="form-control"
                    id="sfccSlasClientSecret"
                    name="sfccSlasClientSecret"
                    autocomplete="off"
                    [(ngModel)]="integration.sfccIntegrationConfig!.slasClientSecret"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="sfccCartAddPath">Cart Add Path</label>
                  <input
                    type="text"
                    class="form-control"
                    id="sfccCartAddPath"
                    name="sfccCartAddPath"
                    [(ngModel)]="integration.sfccIntegrationConfig!.cartAddPath"
                  />
                </div>
                <div class="form-group">
                  <label for="sfccCartUpdatePath">Cart Update Path</label>
                  <input
                    type="text"
                    class="form-control"
                    id="sfccCartUpdatePath"
                    name="sfccCartUpdatePath"
                    [(ngModel)]="integration.sfccIntegrationConfig!.cartUpdatePath"
                  />
                </div>
                <div class="form-group">
                  <label for="sfccCartRemovePath">Cart Remove Path</label>
                  <input
                    type="text"
                    class="form-control"
                    id="sfccCartRemovePath"
                    name="sfccCartRemovePath"
                    [(ngModel)]="integration.sfccIntegrationConfig!.cartRemovePath"
                  />
                </div>
                @if (sfccValidationErrors.length > 0) {
                  <div class="alert alert-warning mb-0">
                    @for (error of sfccValidationErrors; track error) {
                      <div>{{ error }}</div>
                    }
                  </div>
                }
              </div>
            </div>
          }

          <!-- functionality moved to session settings -->
          <!-- <div class="form-group">
              <label class="custom-control" for="embedPreSessionTimeFrame"
                >Hours Before Live Session to Embed</label
                >
                <div class="custom-control">
                  <input
                    type="number"
                    class="form-control"
                    id="embedPreSessionTimeFrame"
                    name="embedPreSessionTimeFrame"
                    placeholder="24"
                    autocomplete="off"
                    [(ngModel)]="embedPreSessionTimeFrame"
                    />
                </div>
              </div> -->

          <div class="mb-4 mt-4" [hidden]="isSfccIntegration">
            <button
              class="btn btn-yellow w-132 mb-4"
              (click)="showMoreSettings = !showMoreSettings"
            >
              {{ showMoreSettings ? 'Hide Settings' : 'More Settings' }}
            </button>

            @if (showMoreSettings) {
              <div>
                <div class="form-group">
                  <label for="productCatalogUrl">Product Catalog URL</label>
                  <input
                    type="text"
                    class="form-control"
                    id="productCatalogUrl"
                    name="productCatalogUrl"
                    placeholder="https://"
                    autocomplete="off"
                    [(ngModel)]="integration.productCatalogUrl"
                    (ngModelChange)="onProductCatalogUrlChange($event)"
                    [required]="isNaturaOrAvonBrazilIntegration"
                  />
                </div>
                @if (isGenericCsvIntegration && storeId) {
                  <div class="form-group">
                    <label for="csvCatalogFile">Upload CSV Catalog</label>
                    <input
                      type="file"
                      class="form-control-file"
                      id="csvCatalogFile"
                      accept=".csv,.tsv,text/csv,text/tab-separated-values"
                      [disabled]="isCsvCatalogUploading"
                      (change)="onCsvCatalogFileSelected($event)"
                    />
                    @if (isCsvCatalogUploading) {
                      <div class="progress mt-2">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          [style.width.%]="csvCatalogUploadProgress"
                        >
                          {{ csvCatalogUploadProgress }}%
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (isGenericCsvIntegration) {
                  <div class="border border-white mb-3">
                    <div class="card-header">CSV Field Mapping</div>
                    <div class="card-body">
                      @if (csvFeedPreviewStatus === 'loading') {
                        <p class="text-muted mb-3">Loading feed headers…</p>
                      } @else if (csvFeedPreviewStatus === 'success') {
                        <p class="text-success mb-3">
                          Found {{ csvFeedHeaders.length }} columns ({{ csvFeedSampleRowCount }}
                          sample rows).
                        </p>
                      } @else if (csvFeedPreviewStatus === 'error') {
                        <p class="text-danger mb-3">{{ csvFeedPreviewError }}</p>
                      } @else {
                        <p class="text-muted mb-3">
                          Enter a product catalog URL to discover CSV headers.
                        </p>
                      }
                      <div class="form-group">
                        <label for="csvDelimiter">Delimiter</label>
                        <ng-select
                          id="csvDelimiter"
                          name="csvDelimiter"
                          [(ngModel)]="integration.csvIntegrationConfig!.delimiter"
                          [clearable]="false"
                        >
                          <ng-option value="auto">Auto-detect</ng-option>
                          <ng-option value=",">Comma</ng-option>
                          <ng-option [value]="csvTabDelimiter">Tab</ng-option>
                        </ng-select>
                      </div>
                      @for (field of csvRequiredFields; track field) {
                        <div class="form-group">
                          <label [for]="`csvField_${field}`">{{ csvFieldLabels[field] }}*</label>
                          <ng-select
                            [id]="`csvField_${field}`"
                            [name]="`csvField_${field}`"
                            [ngModel]="getCsvFieldMapping(field)"
                            (ngModelChange)="setCsvFieldMapping(field, $event)"
                            [clearable]="true"
                            placeholder="— not mapped —"
                          >
                            @for (header of csvFeedHeaders; track header) {
                              <ng-option [value]="header">{{ header }}</ng-option>
                            }
                          </ng-select>
                        </div>
                      }
                      <button
                        type="button"
                        class="btn btn-link px-0 mb-2"
                        (click)="showCsvOptionalFields = !showCsvOptionalFields"
                      >
                        {{
                          showCsvOptionalFields ? 'Hide optional fields' : 'Show optional fields'
                        }}
                      </button>
                      @if (showCsvOptionalFields) {
                        @for (field of csvOptionalFields; track field) {
                          <div class="form-group">
                            <label [for]="`csvOptionalField_${field}`">{{
                              csvFieldLabels[field]
                            }}</label>
                            <ng-select
                              [id]="`csvOptionalField_${field}`"
                              [name]="`csvOptionalField_${field}`"
                              [ngModel]="getCsvFieldMapping(field)"
                              (ngModelChange)="setCsvFieldMapping(field, $event)"
                              [clearable]="true"
                              placeholder="— not mapped —"
                            >
                              @for (header of csvFeedHeaders; track header) {
                                <ng-option [value]="header">{{ header }}</ng-option>
                              }
                            </ng-select>
                          </div>
                        }
                      }
                      <div class="form-group">
                        <label for="csvVariantGrouping">Product grouping (dedup)</label>
                        <p class="form-text text-muted">
                          Rows sharing this field become one product; the first row's External ID is
                          used.
                        </p>
                        <ng-select
                          id="csvVariantGrouping"
                          name="csvVariantGrouping"
                          [ngModel]="getCsvVariantGroupingStrategy()"
                          (ngModelChange)="setCsvVariantGroupingStrategy($event)"
                          [clearable]="false"
                        >
                          @for (option of csvVariantGroupingOptions; track option.value) {
                            <ng-option [value]="option.value">{{ option.label }}</ng-option>
                          }
                        </ng-select>
                      </div>
                      @if (
                        integration.csvIntegrationConfig?.variantGrouping?.strategy ===
                        'customField'
                      ) {
                        <div class="form-group">
                          <label for="csvVariantGroupingCustomField">Custom grouping field</label>
                          <ng-select
                            id="csvVariantGroupingCustomField"
                            name="csvVariantGroupingCustomField"
                            [ngModel]="getCsvVariantGroupingCustomField()"
                            (ngModelChange)="setCsvVariantGroupingCustomField($event)"
                            [clearable]="true"
                            placeholder="— select column —"
                          >
                            @for (header of csvFeedHeaders; track header) {
                              <ng-option [value]="header">{{ header }}</ng-option>
                            }
                          </ng-select>
                        </div>
                      }
                      @if (csvValidationErrors.length > 0) {
                        <div class="alert alert-warning mb-0">
                          @for (error of csvValidationErrors; track error) {
                            <div>{{ error }}</div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
                <div class="form-group">
                  <label for="apiUrl">API URL</label>
                  <input
                    type="text"
                    class="form-control"
                    id="apiUrl"
                    name="apiUrl"
                    placeholder="https://"
                    autocomplete="off"
                    [(ngModel)]="integration.apiUrl"
                    maxlength="100"
                  />
                </div>
                <div class="form-group">
                  <label for="apiToken">API token</label>
                  <input
                    type="text"
                    class="form-control"
                    id="apiToken"
                    name="apiToken"
                    placeholder="Bearer "
                    autocomplete="off"
                    [(ngModel)]="integration.apiToken"
                    maxlength="2000"
                  />
                </div>
                <div class="form-group">
                  <label for="productUniqueIdFieldName">Product ID field name</label>
                  <input
                    type="text"
                    class="form-control"
                    id="productUniqueIdFieldName"
                    name="productUniqueIdFieldName"
                    placeholder="Bearer "
                    autocomplete="off"
                    [(ngModel)]="integration.productUniqueIdFieldName"
                    maxlength="100"
                  />
                </div>
                <div class="form-group">
                  <label for="productVariantUniqueIdFieldName">Product variant ID field name</label>
                  <input
                    type="text"
                    class="form-control"
                    id="productVariantUniqueIdFieldName"
                    name="productVariantUniqueIdFieldName"
                    placeholder="Bearer "
                    autocomplete="off"
                    [(ngModel)]="integration.productVariantUniqueIdFieldName"
                    maxlength="100"
                  />
                </div>
                <div class="form-group">
                  <label for="headerElements">Coma separated header elements</label>
                  <input
                    type="text"
                    class="form-control"
                    id="headerElements"
                    name="headerElements"
                    placeholder=".header,header,#header"
                    autocomplete="off"
                    [(ngModel)]="integration.headerElements"
                    maxlength="100"
                  />
                </div>
                <div class="form-group">
                  <label for="credentialsUsername">Username</label>
                  <input
                    type="text"
                    class="form-control"
                    id="credentialsUsername"
                    name="credentialsUsername"
                    placeholder=""
                    autocomplete="off"
                    [(ngModel)]="integration.credentials.username"
                    maxlength="2000"
                  />
                </div>
                <div class="form-group">
                  <label for="credentialsPassword">Password</label>
                  <input
                    type="text"
                    class="form-control"
                    id="credentialsPassword"
                    name="credentialsPassword"
                    placeholder=""
                    autocomplete="off"
                    [(ngModel)]="integration.credentials.password"
                    maxlength="2000"
                  />
                </div>
                <div class="form-group">
                  <label for="credentialsAccountName">Account Name</label>
                  <input
                    type="text"
                    class="form-control"
                    id="credentialsAccountName"
                    name="credentialsAccountName"
                    placeholder=""
                    autocomplete="off"
                    [(ngModel)]="integration.credentials.accountName"
                    maxlength="2000"
                  />
                </div>
                <div class="form-group">
                  <label for="credentialsEnvironment">Environment</label>
                  <input
                    type="text"
                    class="form-control"
                    id="credentialsEnvironment"
                    name="credentialsEnvironment"
                    placeholder=""
                    autocomplete="off"
                    [(ngModel)]="integration.credentials.environment"
                    maxlength="2000"
                  />
                </div>
              </div>
            }
          </div>
        }

        <div class="form-group">
          <fieldset>
            <legend
              (click)="onFeatureFlagsLegendClick()"
              style="cursor: default; user-select: none"
            >
              Feature Flags:
            </legend>
            <div class="custom-control custom-checkbox mb-2">
              <input
                type="checkbox"
                class="custom-control-input"
                id="enableLiveSession"
                name="enableLiveSession"
                [(ngModel)]="integration.productFlags.liveSessions"
              />
              <label class="custom-control-label feature-flag-label" for="enableLiveSession"
                >Live Sessions</label
              >
            </div>
            @if (integration.productFlags.liveSessions) {
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="embedPostSession"
                  name="embedPostSession"
                  [(ngModel)]="embedPostSession"
                />
                <label class="custom-control-label" for="embedPostSession"
                  >Embed Post Session</label
                >
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="isAutoCheckoutEnabled"
                  name="isAutoCheckoutEnabled"
                  [(ngModel)]="store.isAutoCheckoutEnabled"
                />
                <label class="custom-control-label" for="isAutoCheckoutEnabled"
                  >Auto Checkout</label
                >
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="pictureInPicture"
                  name="pictureInPicture"
                  [(ngModel)]="pictureInPicture"
                />
                <label class="custom-control-label" for="pictureInPicture"
                  >Picture in picture</label
                >
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="hostVideoGrid"
                  name="hostVideoGrid"
                  [(ngModel)]="hostVideoGrid"
                />
                <label class="custom-control-label" for="hostVideoGrid">Host Video Grid</label>
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="enableStreaming"
                  name="enableStreaming"
                  [(ngModel)]="enableStreaming"
                />
                <label class="custom-control-label" for="enableStreaming">Streaming</label>
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="enableYoutubeStreaming"
                  name="enableYoutubeStreaming"
                  [(ngModel)]="enableYoutubeStreaming"
                />
                <label class="custom-control-label" for="enableYoutubeStreaming"
                  >YouTube Streaming</label
                >
              </div>
              @if (store.id && storesIdsThatSupportColorPalate.includes(store.id)) {
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="colorPalateSelector"
                    name="colorPalateSelector"
                    [(ngModel)]="store.colorPalateSelector"
                  />
                  <label class="custom-control-label" for="colorPalateSelector">
                    Support the color palette
                  </label>
                </div>
              }
              @if (showDevFeatureFlags) {
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="enableAISuggestionsInLiveSession"
                    name="enableAISuggestionsInLiveSession"
                    [(ngModel)]="enableAISuggestionsInLiveSession"
                  />
                  <label class="custom-control-label" for="enableAISuggestionsInLiveSession"
                    >AI Suggestions in live session (Alpha version)</label
                  >
                </div>
              }
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="enableMediaGateway"
                  name="enableMediaGateway"
                  [(ngModel)]="enableMediaGateway"
                />
                <label class="custom-control-label" for="enableMediaGateway"
                  >External Broadcast</label
                >
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="enableTalkingPointsAnalysis"
                  name="enableTalkingPointsAnalysis"
                  [(ngModel)]="enableTalkingPointsAnalysis"
                />
                <label class="custom-control-label" for="enableTalkingPointsAnalysis"
                  >Talking Points (Copilot)</label
                >
              </div>
              @if (showDevFeatureFlags) {
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="enableTranscription"
                    name="enableTranscription"
                    [(ngModel)]="enableTranscription"
                  />
                  <label class="custom-control-label" for="enableTranscription"
                    >Transcription</label
                  >
                </div>
              }
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="enableLiveSessionIntelligenceAnalysis"
                  name="enableLiveSessionIntelligenceAnalysis"
                  [(ngModel)]="enableLiveSessionIntelligenceAnalysis"
                />
                <label class="custom-control-label" for="enableLiveSessionIntelligenceAnalysis"
                  >Live Session Intelligence Analysis</label
                >
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="showCameraSelectOnMobile"
                  name="showCameraSelectOnMobile"
                  [(ngModel)]="showCameraSelectOnMobile"
                />
                <label class="custom-control-label" for="showCameraSelectOnMobile"
                  >Show Camera select on mobile</label
                >
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="enableCountdownBuffer"
                  name="enableCountdownBuffer"
                  [(ngModel)]="enableCountdownBuffer"
                />
                <label class="custom-control-label" for="enableCountdownBuffer"
                  >Enable 30 Second Countdown Buffer</label
                >
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="muteOnMinimize"
                  name="muteOnMinimize"
                  [(ngModel)]="muteOnMinimize"
                />
                <label class="custom-control-label" for="muteOnMinimize">Mute on minimize</label>
              </div>
              @if (showDevFeatureFlags) {
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="enableHorizontalMode"
                    name="enableHorizontalMode"
                    [(ngModel)]="enableHorizontalMode"
                  />
                  <label class="custom-control-label" for="enableHorizontalMode"
                    >Horizontal Mode (session settings)</label
                  >
                </div>
              }
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="displayExternalVideoInputs"
                  name="displayExternalVideoInputs"
                  [(ngModel)]="displayExternalVideoInputs"
                />
                <label class="custom-control-label" for="displayExternalVideoInputs"
                  >Display external video inputs</label
                >
              </div>
              <div class="form-group mb-2 ml-4">
                <label for="broadcastResolution">Broadcast Resolution</label>
                <ng-select
                  id="broadcastResolution"
                  name="Broadcast resolution"
                  [(ngModel)]="broadcastResolution"
                  autocomplete="off"
                  [clearable]="false"
                >
                  @for (item of broadcastResolutionSelect | keyvalue; track item.key) {
                    <ng-option [value]="item.key">{{ item.value }}</ng-option>
                  }
                </ng-select>
              </div>
            }
            <div class="custom-control custom-checkbox mb-2">
              <input
                type="checkbox"
                class="custom-control-input"
                id="enableSceneBuilder"
                name="enableSceneBuilder"
                [(ngModel)]="integration.productFlags.sceneBuilder"
              />
              <label class="custom-control-label feature-flag-label" for="enableSceneBuilder"
                >Scene Builder</label
              >
            </div>
            <div class="custom-control custom-checkbox mb-2">
              <input
                type="checkbox"
                class="custom-control-input"
                id="enableCarousels"
                name="enableCarousels"
                [(ngModel)]="integration.productFlags.carousels"
              />
              <label class="custom-control-label feature-flag-label" for="enableCarousels"
                >Carousels</label
              >
            </div>
            @if (integration.productFlags.carousels) {
              @if (showDevFeatureFlags) {
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="carouselAdReports"
                    name="carouselAdReports"
                    [(ngModel)]="carouselAdReports"
                  />
                  <label class="custom-control-label" for="carouselAdReports"
                    >Carousel Ad Reports</label
                  >
                </div>
              }
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="carouselsMediaStartsMuted"
                  name="carouselsMediaStartsMuted"
                  [(ngModel)]="carouselsMediaStartsMuted"
                />
                <label class="custom-control-label" for="carouselsMediaStartsMuted"
                  >Carousels media starts muted</label
                >
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="lazyEmbedCarouselEnabled"
                  name="lazyEmbedCarouselEnabled"
                  [(ngModel)]="lazyEmbedCarouselEnabled"
                />
                <label class="custom-control-label" for="lazyEmbedCarouselEnabled"
                  >Lazy embed carousel</label
                >
              </div>
              @if (lazyEmbedCarouselEnabled) {
                <div class="form-group mb-2 ml-5">
                  <label for="lazyEmbedCarouselDesktop">Desktop factor (count of screens)</label>
                  <input
                    type="number"
                    class="form-control"
                    id="lazyEmbedCarouselDesktop"
                    name="lazyEmbedCarouselDesktop"
                    [(ngModel)]="lazyEmbedCarouselDesktop"
                    min="0"
                    step="0.1"
                  />
                </div>
                <div class="form-group mb-2 ml-5">
                  <label for="lazyEmbedCarouselMobile">Mobile factor (count of screens)</label>
                  <input
                    type="number"
                    class="form-control"
                    id="lazyEmbedCarouselMobile"
                    name="lazyEmbedCarouselMobile"
                    [(ngModel)]="lazyEmbedCarouselMobile"
                    min="0"
                    step="0.1"
                  />
                </div>
              }
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="showDisplayVerticalNavDesktop"
                  name="showDisplayVerticalNavDesktop"
                  [(ngModel)]="showDisplayVerticalNavDesktop"
                />
                <label class="custom-control-label" for="showDisplayVerticalNavDesktop"
                  >Show display vertical nav on desktop</label
                >
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="showDisplayVerticalNavMobile"
                  name="showDisplayVerticalNavMobile"
                  [(ngModel)]="showDisplayVerticalNavMobile"
                />
                <label class="custom-control-label" for="showDisplayVerticalNavMobile"
                  >Show display vertical nav on mobile</label
                >
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="useBrandedPollsDomain"
                  name="useBrandedPollsDomain"
                  [(ngModel)]="useBrandedPollsDomain"
                />
                <label class="custom-control-label" for="useBrandedPollsDomain"
                  >Use polls.terrific.live for carousels</label
                >
              </div>
              @if (showDevFeatureFlags) {
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="carouselTopButtonsLayout"
                    name="carouselTopButtonsLayout"
                    [(ngModel)]="carouselTopButtonsLayout"
                  />
                  <label class="custom-control-label" for="carouselTopButtonsLayout"
                    >Carousel Top Buttons Layout</label
                  >
                </div>
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="lazyVideoPreload"
                    name="lazyVideoPreload"
                    [(ngModel)]="lazyVideoPreload"
                  />
                  <label class="custom-control-label" for="lazyVideoPreload"
                    >Carousel lazy video preload</label
                  >
                </div>
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="ctaClickedPostMessage"
                    name="ctaClickedPostMessage"
                    [(ngModel)]="ctaClickedPostMessage"
                  />
                  <label class="custom-control-label" for="ctaClickedPostMessage"
                    >CTA click sends postMessage</label
                  >
                </div>
              }
              @if (showDevFeatureFlags) {
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="mapBrandNameToProductName"
                    name="mapBrandNameToProductName"
                    [(ngModel)]="mapBrandNameToProductName"
                  />
                  <label class="custom-control-label" for="mapBrandNameToProductName"
                    >Map Brand Name to Product Name in product card</label
                  >
                </div>
              }
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="voteResultsAfterVote"
                  name="voteResultsAfterVote"
                  [(ngModel)]="voteResultsAfterVote"
                />
                <label class="custom-control-label" for="voteResultsAfterVote"
                  >Show Vote Results Only After Vote</label
                >
              </div>
              @if (showDevFeatureFlags) {
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="frenchTimestampFormat"
                    name="frenchTimestampFormat"
                    [(ngModel)]="frenchTimestampFormat"
                  />
                  <label class="custom-control-label" for="frenchTimestampFormat"
                    >DD/MM/YYYY - HHhMM timestamp format</label
                  >
                </div>
              }
              <div class="mb-2 ml-4">
                <label for="timelineAds">Ads</label>
                <div class="custom-control custom-checkbox mb-2 ml-3">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="timelineAds"
                    name="timelineAds"
                    [(ngModel)]="timelineAds"
                  />
                  <label class="custom-control-label" for="timelineAds">Vertical Ads</label>
                </div>
                <div class="custom-control custom-checkbox mb-2 ml-3">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="horizontalCarouselAds"
                    name="horizontalCarouselAds"
                    [(ngModel)]="horizontalCarouselAds"
                  />
                  <label class="custom-control-label" for="horizontalCarouselAds">
                    Horizontal Carousel Ads
                  </label>
                </div>
                @if (timelineAds || horizontalCarouselAds) {
                  <div class="custom-control custom-checkbox mb-2 ml-3">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="disableAdTimeout"
                      name="disableAdTimeout"
                      [(ngModel)]="disableAdTimeout"
                    />
                    <label class="custom-control-label" for="disableAdTimeout"
                      >Disable Ads Timeout</label
                    >
                  </div>
                }
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="requireLoginForCarouselPollVote"
                  name="requireLoginForCarouselPollVote"
                  [(ngModel)]="requireLoginForCarouselPollVote"
                />
                <label class="custom-control-label" for="requireLoginForCarouselPollVote"
                  >Require Login for Carousel Poll Vote</label
                >
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="enableSocialImports"
                  name="enableSocialImports"
                  [(ngModel)]="enableSocialImports"
                />
                <label class="custom-control-label" for="enableSocialImports">Social Imports</label>
              </div>
              @if (enableSocialImports) {
                <div class="custom-control custom-checkbox mb-2 ml-5">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="socialImportsInstagramCarousels"
                    name="socialImportsInstagramCarousels"
                    [(ngModel)]="importInstagramCarousels"
                  />
                  <label class="custom-control-label" for="socialImportsInstagramCarousels"
                    >Import Instagram Posts as Carousels</label
                  >
                </div>
                <div class="custom-control custom-checkbox mb-2 ml-5">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="useInstagramConnect"
                    name="useInstagramConnect"
                    [(ngModel)]="useInstagramConnect"
                  />
                  <label class="custom-control-label" for="useInstagramConnect"
                    >Instagram Connect</label
                  >
                </div>
                <div class="custom-control custom-checkbox mb-2 ml-5">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="useInstagramConnectOnlyForCarouselImports"
                    name="useInstagramConnectOnlyForCarouselImports"
                    [(ngModel)]="useInstagramConnectOnlyForCarouselImports"
                  />
                  <label
                    class="custom-control-label"
                    for="useInstagramConnectOnlyForCarouselImports"
                    >Use Instagram Connect only for carousel imports (FOR REVIEW DEMO)</label
                  >
                </div>
                <div class="form-group mb-2 ml-5">
                  <label for="socialImportsMaxOnDemandRequestsDaily"
                    >Maximum on-demand social imports per day</label
                  >
                  <input
                    type="number"
                    class="form-control"
                    id="socialImportsMaxOnDemandRequestsDaily"
                    name="socialImportsMaxOnDemandRequestsDaily"
                    autocomplete="on"
                    min="0"
                    max="99"
                    [(ngModel)]="socialImportsMaxOnDemandRequestsDaily"
                  />
                </div>
                <div class="form-group mb-2 ml-5">
                  <label for="socialImportsMaxItemsPerImport">Maximum items per import</label>
                  <input
                    type="number"
                    class="form-control"
                    id="socialImportsMaxItemsPerImport"
                    name="socialImportsMaxItemsPerImport"
                    autocomplete="on"
                    step="1"
                    [min]="socialImportsItemsPerImportLimits.min"
                    [max]="socialImportsItemsPerImportLimits.max"
                    placeholder="8"
                    [(ngModel)]="socialImportsMaxItemsPerImport"
                  />
                </div>
              }

              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="enableCarouselAutomations"
                  name="enableCarouselAutomations"
                  [(ngModel)]="enableCarouselAutomations"
                />
                <label class="custom-control-label" for="enableCarouselAutomations"
                  >Carousel Automations</label
                >
              </div>

              @if (showDevFeatureFlags && store.storeCategory === StoreCategory.Media) {
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="smartContentCarousels"
                    name="smartContentCarousels"
                    [(ngModel)]="smartContentCarousels"
                  />
                  <label class="custom-control-label" for="smartContentCarousels"
                    >Smart Content carousels</label
                  >
                </div>
              }
              @if (showDevFeatureFlags && store.storeCategory === StoreCategory.Media) {
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="tinderSwipe"
                    name="tinderSwipe"
                    [(ngModel)]="tinderSwipe"
                  />
                  <label class="custom-control-label" for="tinderSwipe">Tinder-Swipe</label>
                </div>
              }
              @if (showDevFeatureFlags) {
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="enableSmartStrategy"
                    name="enableSmartStrategy"
                    [(ngModel)]="enableSmartStrategy"
                  />
                  <label class="custom-control-label" for="enableSmartStrategy"
                    >Smart Strategy tab</label
                  >
                </div>
              }
              @if (showDevFeatureFlags && store.storeCategory === StoreCategory.Media) {
                <div class="custom-control custom-checkbox mb-2 ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="enableAiVideoCategorization"
                    name="enableAiVideoCategorization"
                    [(ngModel)]="enableAiVideoCategorization"
                  />
                  <label class="custom-control-label" for="enableAiVideoCategorization"
                    >AI Video Categorization</label
                  >
                </div>
              }
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="enableSwipeShop"
                  name="enableSwipeShop"
                  [(ngModel)]="enableSwipeShop"
                />
                <label class="custom-control-label" for="enableSwipeShop">Swipe Shop</label>
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="enableCarouselExecutiveDashboard"
                  name="enableCarouselExecutiveDashboard"
                  [(ngModel)]="enableCarouselExecutiveDashboard"
                />
                <label class="custom-control-label" for="enableCarouselExecutiveDashboard"
                  >Carousel Executive Dashboard</label
                >
              </div>
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="enableCarouselOverviewRowMetrics"
                  name="enableCarouselOverviewRowMetrics"
                  [(ngModel)]="enableCarouselOverviewRowMetrics"
                />
                <label class="custom-control-label" for="enableCarouselOverviewRowMetrics"
                  >Carousel Overview Row Metrics</label
                >
              </div>
              <div class="form-group mb-2 ml-4">
                <label for="maximumTimelineVideoLength"
                  >Maximum timeline video length (seconds)</label
                >
                <input
                  type="number"
                  class="form-control"
                  id="maximumTimelineVideoLength"
                  name="maximumTimelineVideoLength"
                  placeholder="120"
                  autocomplete="on"
                  [(ngModel)]="maximumTimelineVideoLength"
                />
              </div>
            }
            <div class="custom-control custom-checkbox mb-2">
              <input
                type="checkbox"
                class="custom-control-input"
                id="enableHub"
                name="enableHub"
                [(ngModel)]="enableHub"
              />
              <label class="custom-control-label feature-flag-label" for="enableHub"
                >Intelligence hub</label
              >
            </div>
            <div class="custom-control custom-checkbox mb-2">
              <input
                type="checkbox"
                class="custom-control-input"
                id="enableLiveForum"
                name="enableLiveForum"
                [(ngModel)]="enableLiveForum"
              />
              <label class="custom-control-label feature-flag-label" for="enableLiveForum"
                >Live Forum</label
              >
            </div>
            @if (enableLiveForum) {
              <div class="custom-control custom-checkbox mb-2 ml-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="enableLiveForumIpAllowlist"
                  name="enableLiveForumIpAllowlist"
                  [(ngModel)]="enableLiveForumIpAllowlist"
                />
                <label
                  class="custom-control-label feature-flag-label"
                  for="enableLiveForumIpAllowlist"
                  >Restrict Live Forum admin access by IP</label
                >
              </div>
              @if (enableLiveForumIpAllowlist) {
                <div class="container ml-4 mb-2">
                  @for (ip of store.ipAllowlist ?? []; track $index) {
                    <div class="input-group mb-2">
                      <input
                        type="text"
                        [ngModel]="ip"
                        (ngModelChange)="onIpAllowlistEntryChange($index, $event)"
                        [name]="`ipAllowlist-${$index}`"
                        class="form-control"
                        placeholder="e.g. 194.169.175.0/23"
                      />
                      <div class="input-group-append">
                        <button
                          type="button"
                          class="btn btn-danger"
                          (click)="removeIpAllowlistEntry($index)"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn btn-primary" (click)="addNewIpAllowlistEntry()">
                    Add IP
                  </button>
                </div>
              }
            }
            <div class="custom-control custom-checkbox mb-2">
              <input
                type="checkbox"
                class="custom-control-input"
                id="tiendaNubeApplicationAccess"
                name="tiendaNubeApplicationAccess"
                [(ngModel)]="tiendaNubeApplicationAccess"
              />
              <label
                class="custom-control-label feature-flag-label"
                for="tiendaNubeApplicationAccess"
                >Tienda Nube application access</label
              >
            </div>
            @if (showDevFeatureFlags) {
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="enableStripeAdminBilling"
                  name="enableStripeAdminBilling"
                  [(ngModel)]="enableStripeAdminBilling"
                />
                <label
                  class="custom-control-label feature-flag-label"
                  for="enableStripeAdminBilling"
                  >Stripe Admin Billing</label
                >
              </div>
            }
          </fieldset>
        </div>

        <div class="form-group">
          <label for="storeType">Allowed domains</label>
          <div class="container allowed-domains-container">
            <table class="table">
              <thead>
                <tr>
                  <th>Address Pattern</th>
                  <th>Created At</th>
                  <th>Enabled</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (item of store.allowedDomains; track trackById($index, item)) {
                  <tr>
                    <td>
                      <input
                        type="text"
                        [ngModel]="item.addressPattern"
                        (ngModelChange)="onAllowedDomainAddressPatternChange(item, $event)"
                        [name]="`addressPattern-${$index}`"
                        class="form-control"
                        placeholder="Edit address pattern"
                      />
                    </td>

                    <td>{{ formatDate(item.createdAt) }}</td>
                    <td>
                      <input
                        type="checkbox"
                        [ngModel]="item.isEnabled"
                        (ngModelChange)="onAllowedDomainEnabledChange(item, $event)"
                        [name]="`isEnabled-${$index}`"
                      />
                    </td>
                    <td>
                      <button class="btn btn-danger" (click)="removeItem($index)">Remove</button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <button class="btn btn-primary mb-3 add-domain-button" (click)="addNewAllowedDomain()">
              Add New Domain
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-yellow w-132"
    (click)="save(storeForm)"
    [disabled]="isSubmitting"
  >
    Save
  </button>
</div>
